export default "__VITE_ASSET__2a68bee5__"